import React from "react";
import { Link } from "react-router-dom";
import chooseBg from "../../assets/img/choose/guidance_background.jpg";
import chooseLeftBg from "../../assets/img/choose/guidance_left_bg.png";

export const ChooseAreaTwo = () => {
  const groups = [
    {
      title: "We do",
      items: [
        "Record and categorize every transaction",
        "Reconcile bank and credit card accounts",
        "Set up QuickBooks Online or Xero",
        "Catch up books that are behind",
      ],
    },
    {
      title: "We don't do",
      items: [
        "Tax returns or GST/PST filing",
        "Financial statements or audits",
      ],
    },
  ];

  return (
    <section
      className="choose-area choose-area-about jarallax choose-bg"
      style={{ backgroundImage: `url(${chooseBg})` }}
    >
      <div className="choose-shape">
        <img
          src={chooseLeftBg}
          alt=""
          data-aos="fade-right"
          data-aos-delay="0"
        />
      </div>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="choose-content">
              <div className="section-title-two white-title mb-20 tg-heading-subheading animation-style3">
                <h2 className="title tg-element-title">
                Bookkeeping Only, Done Properly
                </h2>
              </div>
              <p>
              Silverwave provides bookkeeping services. We don't prepare tax returns, 
              GST/PST returns or financial statements, but we keep your records accurate and 
              ready for the professional who does. We work in person in Surrey or online.
              </p>

              <Link to="/contact" className="btn">
                Ask a Question
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="skill-wrap wow fadeInRight" data-wow-delay=".2s">
              <div className="section-title-two mb-15">
                <span className="sub-title">Clear Scope</span>
                <h2 className="title">What We Do and Don't Do</h2>
              </div>
              <p>
              Knowing this up front saves time for everyone.
              </p>
              {groups.map((group) => (
                <div className="scope-group" key={group.title}>
                  <h3 className="scope-list-title">{group.title}</h3>
                  <div className="about-list-two">
                    <ul className="list-wrap">
                      {group.items.map((item) => (
                        <li key={item}>
                          <i className="fas fa-arrow-right"></i> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
